export class TimeUtils {
  static getFormattedTimeDifference(givenTimestamp) {
    const currentTimeMillis = Date.now();
    const differenceMillis = currentTimeMillis - givenTimestamp;

    const seconds = Math.floor(differenceMillis / 1000);
    const minutes = Math.floor(differenceMillis / (1000 * 60));
    const hours = Math.floor(differenceMillis / (1000 * 60 * 60));
    const days = Math.floor(differenceMillis / (1000 * 60 * 60 * 24));

    if (seconds < 60) return "Just now";
    if (minutes < 60) return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
    if (hours < 24) return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
    if (days < 30) return `${days} ${days === 1 ? "day" : "days"} ago`;
    if (days < 365) return `${Math.floor(days / 30)} ${Math.floor(days / 30) === 1 ? "month" : "months"} ago`;
    return `${Math.floor(days / 365)} ${Math.floor(days / 365) === 1 ? "year" : "years"} ago`;
  }

  static getFormattedTimeDifferenceBetween(startTimestamp, endTimestamp) {
    const differenceMillis = endTimestamp - startTimestamp;
    const seconds = Math.floor(differenceMillis / 1000);
    const minutes = Math.floor(differenceMillis / (1000 * 60));
    const hours = Math.floor(differenceMillis / (1000 * 60 * 60));
    const days = Math.floor(differenceMillis / (1000 * 60 * 60 * 24));

    if (seconds < 60) return `${seconds} secs`;
    if (minutes < 60) return `${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
    if (hours < 24) return `${hours} ${hours === 1 ? "hour" : "hours"}`;
    if (days < 30) return `${days} ${days === 1 ? "day" : "days"}`;
    if (days < 365) return `${Math.floor(days / 30)} ${Math.floor(days / 30) === 1 ? "month" : "months"}`;
    return `${Math.floor(days / 365)} ${Math.floor(days / 365) === 1 ? "year" : "years"}`;
  }

  static getCurrentFormattedDate(timestamp) {
    return new Date(timestamp).toISOString().split('T')[0];
  }

  static getCurrentFormattedDateAlt(timestamp) {
    const date = new Date(timestamp);
    return `${date.getMonth() + 1}/${date.getFullYear()}`;
  }

  static getCurrentFormattedDateFullAlt(timestamp) {
    const date = new Date(timestamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }

  static getCurrentFormattedTime(timestampInMillis) {
    return new Date(timestampInMillis).toISOString().replace('T', ' ').split('.')[0];
  }

  static getFormattedTimeTaken(diffInSecs) {
    const h = Math.floor(diffInSecs / 3600).toString().padStart(2, '0');
    const m = Math.floor((diffInSecs % 3600) / 60).toString().padStart(2, '0');
    const s = (diffInSecs % 60).toString().padStart(2, '0');
    return `${h}:${m}:${s}`;
  }

  static getStatus(startTimestamp, endTimestamp) {
    const currentTimeMillis = Date.now();
    if (currentTimeMillis < startTimestamp) return "UPCOMING";
    if (currentTimeMillis >= startTimestamp && currentTimeMillis <= endTimestamp) return "ONGOING";
    return "ENDED";
  }

  static getTimeSpent(startTimestamp, endTimestamp) {
    let diffInMillis = endTimestamp - startTimestamp;

    const years = Math.floor(diffInMillis / (1000 * 60 * 60 * 24 * 365));
    diffInMillis %= (1000 * 60 * 60 * 24 * 365);

    const months = Math.floor(diffInMillis / (1000 * 60 * 60 * 24 * 30));
    diffInMillis %= (1000 * 60 * 60 * 24 * 30);

    const days = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
    diffInMillis %= (1000 * 60 * 60 * 24);

    const hours = Math.floor(diffInMillis / (1000 * 60 * 60));
    diffInMillis %= (1000 * 60 * 60);

    const minutes = Math.floor(diffInMillis / (1000 * 60));

    let result = [];
    if (years > 0) result.push(`${years}y`);
    if (months > 0) result.push(`${months}m`);
    if (days > 0) result.push(`${days}d`);
    if (hours > 0) result.push(`${hours}h`);
    if (minutes > 0) result.push(`${minutes}m`);

    return result.length ? result.join(' ') : "0 minutes";
  }

  static getFormattedDate(stringDatetime) {
    return stringDatetime ? this.getCurrentFormattedDate(Number(stringDatetime)) : this.getCurrentFormattedDate(Date.now());
  }

  static getTimeInMillis() {
    return Date.now();
  }

  static getTimestampFromDatetimeCompat(datetime) {
    return new Date(datetime).getTime() || 0;
  }
  static getDateAndTimeFromTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const res = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return res
  }
  static formatTime(seconds) {
    const hrs = Math.floor(seconds / 3600)
    const mins = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`
  }
}
